export default __webpack_public_path__ + "3c6a8b909e567bf60fd0661e9178a75a.png";